import {
    DELETE_PAYORDER_SUCCESS,
    DELETE_PAYORDER_FAILED,
    DELETE_PAYORDER_INVALID_REQUEST,
    DELETE_PAYORDER_WALLET_ID_NOT_FOUND,
    DELETE_PAYORDER_ACCOUNT_NOT_EXISTS,
    LOADING_DELETE_PAYORDER,
    RESET_DELETE_PAYORDER
} from "../types";

const initialState = {
    isLoading: false,
    deleteSuccess: false,
    deleteFailed: false,
    deleteInvalidRequest: false,
    deleteInvalidWalletOwnerId: false,
    deleteAccountNotExists: false,
    data: {},
    status: ""
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_DELETE_PAYORDER:
            return {
                ...state,
                isLoading: true,
                deleteSuccess: false,
                deleteFailed: false,
                deleteInvalidRequest: false,
                deleteInvalidWalletOwnerId: false,
                deleteAccountNotExists: false,
                data: {},
                status: ""
            };
        case DELETE_PAYORDER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                deleteSuccess: true,
                deleteFailed: false,
                deleteInvalidRequest: false,
                deleteInvalidWalletOwnerId: false,
                deleteAccountNotExists: false,
                data: {},
                status: ""
            };
        case DELETE_PAYORDER_FAILED:
            return {
                ...state,
                isLoading: false,
                deleteSuccess: false,
                deleteFailed: true,
                deleteInvalidRequest: false,
                deleteInvalidWalletOwnerId: false,
                deleteAccountNotExists: false,
                data: {},
                status: "Delete Pay Order Failed"
            };
        case DELETE_PAYORDER_INVALID_REQUEST:
            return {
                ...state,
                isLoading: false,
                deleteSuccess: false,
                deleteFailed: false,
                deleteInvalidRequest: true,
                deleteInvalidWalletOwnerId: false,
                deleteAccountNotExists: false,
                data: {},
                status: "Invalid Request"
            };
        case DELETE_PAYORDER_WALLET_ID_NOT_FOUND:
            return {
                ...state,
                isLoading: false,
                deleteSuccess: false,
                deleteFailed: false,
                deleteInvalidRequest: false,
                deleteInvalidWalletOwnerId: true,
                deleteAccountNotExists: false,
                data: {},
                status: "Invalid Wallet Owner ID"
            };
        case DELETE_PAYORDER_ACCOUNT_NOT_EXISTS:
            return {
                ...state,
                isLoading: false,
                deleteSuccess: false,
                deleteFailed: false,
                deleteInvalidRequest: false,
                deleteInvalidWalletOwnerId: false,
                deleteAccountNotExists: true,
                data: {},
                status: "Account Does Not Exist"
            };
        case RESET_DELETE_PAYORDER:
            return (state = initialState);

        default:
            return state;
    }
};